export default __webpack_public_path__ + "static/media/download.29e4b375.svg";